import { usePortfolioAbilities } from "portfolio/composables/usePortfolioAbilities";
import type { AbilityResolver } from "shared/constants/abilityResolvers.constants";
import { PORTFOLIO_ABILITIES } from "./abilities.constants";

export const portfolioAbilityResolvers: Record<string, AbilityResolver> = {
  [PORTFOLIO_ABILITIES.CAN_CREATE_TASK]: async () => {
    const { canCreateTask, loadAbilities } = usePortfolioAbilities();
    await loadAbilities();
    return canCreateTask.value;
  },
  [PORTFOLIO_ABILITIES.CAN_CREATE_PUBLIC_TASK]: async () => {
    const { canCreatePublicTask, loadAbilities } = usePortfolioAbilities();
    await loadAbilities();
    return canCreatePublicTask.value;
  },
  [PORTFOLIO_ABILITIES.CAN_CREATE_TEMPLATE]: async () => {
    const { canCreateTemplate, loadAbilities } = usePortfolioAbilities();
    await loadAbilities();
    return canCreateTemplate.value;
  },
};
